document.addEventListener('DOMContentLoaded', () => {

  if (document.querySelector('.listing-page .views-element-container') != null) {
    let checboxSection = document.querySelector('.form-composite').offsetHeight;
    let checkboxHeight = checboxSection + 250;
    document.querySelector('.views-element-container').style.minHeight = checkboxHeight + 'px';

    let newElem = document.createElement('div');
    newElem.classList.add('filters-wrapper');
    Array.prototype.forEach.call(document.querySelectorAll('.form-composite, .js-form-item-title'), function (c) {
      newElem.appendChild(c);
    });
    document.querySelector('.views-exposed-form').appendChild(newElem);
  }

  // Clone html
  if (document.querySelector('.listing-page .container > .filter-toggle-wrapper') != null) {
    let source = document.querySelector('.listing-page .container > .filter-toggle-wrapper');
    let cloned = source.cloneNode(true);
    cloned.classList.add('is-hidden');
    document.querySelector('.listing-page .container').prepend(cloned);
    document.querySelector('.views-exposed-form').prepend(source);
  }

  //Trigger Filters
  let filterstrigger = document.querySelectorAll('.filter-toggle');
  if (filterstrigger.length > 0) {
    filterstrigger.forEach( el => {
      el.addEventListener('click', () => {
        el.classList.add('clicked');
        el.parentNode.classList.add('is-opened');
        el.nextElementSibling.style.opacity = '1';
        document.querySelector('.filters-wrapper').classList.add('is-opened');
      });
    });
  }

  // Close filters
  let filtersclose = document.querySelectorAll('.filter-close');
  if (filtersclose.length > 0) {
    filtersclose.forEach( el => {
      el.addEventListener('click', () => {
        el.style.opacity = '0';
        el.parentNode.classList.remove('is-opened');
        el.previousElementSibling.classList.remove('clicked');
        document.querySelector('.filters-wrapper').classList.remove('is-opened');
      });
    });
  }
});

jQuery(document).ajaxComplete(function() {
  if (document.querySelector('.listing-page .views-element-container') != null) {
    let checboxSection = document.querySelector('.form-composite').offsetHeight;
    let checkboxHeight = checboxSection + 250;
    document.querySelector('.views-element-container').style.minHeight = checkboxHeight + 'px';

    let newElem = document.createElement('div');
    newElem.classList.add('filters-wrapper');
    Array.prototype.forEach.call(document.querySelectorAll('.form-composite, .js-form-item-title'), function (c) {
      newElem.appendChild(c);
    });
    document.querySelector('.views-exposed-form').appendChild(newElem);
  }

  // Clone html
  if (document.querySelector('.listing-page .container > .filter-toggle-wrapper') != null) {
    let source = document.querySelector('.listing-page .container > .filter-toggle-wrapper');
    source.classList.remove('is-hidden');
    let cloned = source.cloneNode(true);

    cloned.classList.add('is-hidden');
    document.querySelector('.listing-page .container').prepend(cloned);
    document.querySelector('.views-exposed-form').prepend(source);
  }

  //Trigger Filters
  let filterstrigger = document.querySelectorAll('.filter-toggle');
  if (filterstrigger.length > 0) {
    filterstrigger.forEach( el => {
      el.addEventListener('click', () => {
        el.classList.add('clicked');
        el.parentNode.classList.add('is-opened');
        el.nextElementSibling.style.opacity = '1';
        document.querySelector('.filters-wrapper').classList.add('is-opened');
      });
    });
  }

  // Close filters
  let filtersclose = document.querySelectorAll('.filter-close');
  if (filtersclose.length > 0) {
    filtersclose.forEach( el => {
      el.addEventListener('click', () => {
        el.style.opacity = '0';
        el.parentNode.classList.remove('is-opened');
        el.previousElementSibling.classList.remove('clicked');
        document.querySelector('.filters-wrapper').classList.remove('is-opened');
      });
    });
  }
});

